export default __webpack_public_path__ + "static/media/icon-analytics.afbc31c8.svg";